// =============================================================================
// features/crm/components/SpotlightCard.tsx — Card com hover Spotlight (halo
// verde segue o cursor via `--mx`/`--my`, DS §8) usado pela timeline e pelos
// blocos de dados do detalhe de lead.
//
// Extraído de CrmDetailPage.tsx (F49-S03) para ser reutilizável por
// LivechatGroupCard.tsx sem import circular entre os dois arquivos.
// =============================================================================

import * as React from 'react';

import { cn } from '../../../lib/cn';

export function SpotlightCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string | undefined;
}): React.JSX.Element {
  const cardRef = React.useRef<HTMLDivElement>(null);

  const handleMouseMove = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const el = cardRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - rect.left}px`);
    el.style.setProperty('--my', `${e.clientY - rect.top}px`);
  }, []);

  const handleMouseLeave = React.useCallback(() => {
    const el = cardRef.current;
    if (!el) return;
    el.style.setProperty('--mx', '-9999px');
    el.style.setProperty('--my', '-9999px');
  }, []);

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={cn(
        'relative overflow-hidden rounded-md border border-border bg-surface-1',
        'transition-[transform,box-shadow] duration-[250ms] ease-out',
        'hover:-translate-y-0.5',
        '[--mx:-9999px] [--my:-9999px]',
        className,
      )}
      style={{ boxShadow: 'var(--elev-2)' }}
    >
      {/* Spotlight radial */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 rounded-md"
        style={{
          background:
            'radial-gradient(350px circle at var(--mx) var(--my), rgba(46,155,62,0.07), transparent 60%)',
        }}
      />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
